import { useLocale } from "next-intl";
import { useQuery } from "@tanstack/react-query";
import { fetchCMS } from "@/graphql/client/client";

import { GET_MICE_FORM_DATA } from "@/queries/miceQueries";
import { GET_MICE_FORM_VALIDATION_MESSAGES } from "@/queries/miceDetailQueries";
import {
  MiceFormDataQuery,
  MiceFormDataQueryVariables,
  MiceFormValidationMessagesQuery,
  MiceFormValidationMessagesQueryVariables,
} from "@/types/generated";
import { CONTENT_STATUS } from "@/constants";

/**
 * Hook: useGetFormLabelsQuery
 * Fetches form labels data from the CMS for the current locale.
 */
export const useGetFormLabelsQuery = () => {
  const locale = useLocale();

  return useQuery<MiceFormDataQuery>({
    queryKey: ["mice-form-labels", locale],
    queryFn: () =>
      fetchCMS<MiceFormDataQuery>(GET_MICE_FORM_DATA, {
        locale,
        lightBoxDatasourceDocId: "2c0e4fd656cb421ad1cc2cbd",
        status: CONTENT_STATUS.PUBLISHED,
      } as MiceFormDataQueryVariables),
  });
};

/**
 * Hook: useGetValidationMessagesQuery
 * Fetches validation message templates used to build dynamic Zod schemas.
 */
export const useGetValidationMessagesQuery = () => {
  const locale = useLocale();

  return useQuery<MiceFormValidationMessagesQuery>({
    queryKey: ["mice-form-validation-messages", locale],
    queryFn: () =>
      fetchCMS<MiceFormValidationMessagesQuery>(
        GET_MICE_FORM_VALIDATION_MESSAGES,
        {
          locale,
          status: CONTENT_STATUS.PUBLISHED,
          documentIds: [
            "0afda7ce30242221b92fffdb",
            "3a89df71e2a7f0e8568e7964",
            "d3396370cc7f42df91d5e680",
            "e7bc3ec01039398fe250d9f7",
          ],
        } as MiceFormValidationMessagesQueryVariables,
      ),
  });
};
